import CBOR from "cbor-js";
export default (function () {

    const error = (message, exception) => {
        if (exception != undefined)
            console.error(exception);
        throw new Error(message);
    }

    const uint8ArrayEquals = (arr1, arr2) => {
        if (arr1.length !== arr2.length) {
            return false;
        }
        for (let i = 0; i < arr1.length; i++) {
            if (arr1[i] !== arr2[i]) {
                return false;
            }
        }
        return true;
    }

    const compareChallenges = (challenge1, challenge2) => {
        const challenge1Decoded = atob(challenge1.replace(/_/g, '/').replace(/-/g, '+'));
        const challenge2Decoded = atob(challenge2.replace(/_/g, '/').replace(/-/g, '+'));

        return challenge1Decoded === challenge2Decoded;
    }

    const sha256 = async (buffer) => {
        const byteArray = new Uint8Array(buffer);
        return crypto.subtle.digest('SHA-256', byteArray);
    }

    const arrayToBase64String = (arrayBuffer) => {
        return btoa(String.fromCharCode(...new Uint8Array(arrayBuffer)));
    }

    const getRpIdHashFromAuthData = (authData) => {
        return authData.slice(0, 32);
    }

    const base64ToUint8Array = (base64String) => {
        const padding = '='.repeat((4 - (base64String.length % 4)) % 4);
        const base64 = (base64String + padding)
        .replace(/\-/g, '+')
        .replace(/_/g, '/');

        const rawData = window.atob(base64);
        const outputArray = new Uint8Array(rawData.length);

        for (let i = 0; i < rawData.length; ++i) {
        outputArray[i] = rawData.charCodeAt(i);
        }

        return outputArray;
    }

    const decodeCBOR = (cborData) => {
        return CBOR.decode(cborData);
    }

    const utf8Decode = (encodedArrayBuffer) => {
        const decoder = new TextDecoder('utf-8');
        const decodedString = decoder.decode(encodedArrayBuffer);
        return decodedString;
    }

    const verifyClientData = (C, options) => {
        if (C.type != "webauthn.create") {
            error("Paso #7 'C.type' debe ser igual a 'webauthn.create'", C.type);
        } else {
            console.log("Paso #7 se cumple que 'C.type' = 'webauthn.create'");
        }
        const optionsChallengeArrayBuffer = Uint8Array.from(atob(options.challenge), c => c.charCodeAt(0));
        
        if (!compareChallenges(C.challenge, options.challenge)) {
            error("Paso #8 'C.challenge' no coincide con el valor en base64 de 'options.challenge'", C.challenge, options.challenge);
        } else {
            console.log("Paso #8 se cumple que 'C.challenge' es igual al valor en base64 de 'options.challenge'");
        }
        const currentDomain = window.location.host.replace(/:\d+$/, '');
        if (C.origin != window.location.origin || options.rp.id != currentDomain) {
            error("Paso #9 ClientData origin no coincide con el origen de replay party", C.origin + " " + options.rp.id);
        } else {
            console.log("Paso #9 Se cumple que 'C.origin' es el origen esperado por el Relying Party (Alison Server)", C.origin);
        }
    }

    return {
        createCredential: async function(options, displayName) {
            const publicKeyCredentialCreationOptions = {
                rp: {
                    id: options.rp.id,
                    name: options.rp.name
                },
                user: {
                  id: new TextEncoder().encode(options.user.id),
                  name: displayName,
                  displayName,
                },
                challenge: base64ToUint8Array(options.challenge),
                pubKeyCredParams: options.pubKeyCredParams,
                timeout: options.timeout,
                excludeCredentials: options.excludeCredentials.map(credential => {
                  return {
                      type: credential.type,
                      id: base64ToUint8Array(credential.id)
                  }
                }),
                authenticatorSelection: {
                    requireResidentKey: false
                },
                attestation: options.attestation,
                extensions: options.extensions
            };
            const credentialCreationOptions = { publicKey: publicKeyCredentialCreationOptions };
            return navigator.credentials.create(credentialCreationOptions);
        },
        checkCredential: async function(credential, options) {
            if (credential.type != "public-key") {
                error("Paso #3 La credencial no es public-key", credential);
            }
            console.log("Paso #3 Verificacion: la credencial creada es de tipo 'public-key'");
            const response = credential.response;
            console.log("Paso #3 sea 'response' el resultado de 'credential.response'", response);
            let clientExtensionResults = this.getClientExtensionResults(credential);
            const JSONtext = utf8Decode(response.clientDataJSON);
            console.log("Paso #5 sea 'JSONtext' el resultado de decodificar en UTF-8 el valor de 'response.clientDataJSON'", JSONtext);
            const C = JSON.parse(JSONtext)
            console.log("Paso #6 sea 'C' el valor de convertir a JSON el valor de 'JSONtext'");
            verifyClientData(C, options)
            console.log("Paso #10 omitido");
            const hash = await sha256(response.clientDataJSON)
            console.log("#Paso #11 sea 'hash' el resultado de 'response.clientDataJSON' usando SHA-256", hash);
            const attestationObject = response.attestationObject;
            const cbor = decodeCBOR(attestationObject);
            console.log("Paso #12 Se usa la decodificacion CBOR sobre 'response.attestationObject' que contiene 'authData'", cbor);
            const { authData } = cbor;
            const rpIdHash = getRpIdHashFromAuthData(authData);
            const rpId = options.rp.id;
            const encoder = new TextEncoder();
            const expectedRpIdHash = new Uint8Array(await crypto.subtle.digest('SHA-256', encoder.encode(rpId)));
            if (!uint8ArrayEquals(rpIdHash, expectedRpIdHash)) {
                error("Paso #13 'rpIdHash' no coincide con el SHA-256 de 'RP ID' esperado por el Relying Party (Alison Server)");
            } else {
                console.log("Paso #13 'rpIdHash' en 'authData' es el SHA-256 de 'RP ID' esperado por el Relying Party (Alison Server)");
            }

            const flagsByte = authData[32];
            const isUserPresent = (flagsByte & 0x01) === 0x01;
            const isBackupEligibilityPresent = ((flagsByte >> 4) & 0x01) === 0x01;
            const isBackupStatePresent = ((flagsByte >> 5) & 0x01) === 0x01;
            if (isUserPresent) {
                console.log("Paso #14 Se verifica que el bit UP (User Present) de los flags en 'authData' este seteado.");
            } else {
                error('Paso #14 El bit UP no está establecido, lo que significa que el usuario no está presente.');
            }
            console.log("Paso #15 omitido");
            if (!isBackupEligibilityPresent && isBackupStatePresent) {
                error("Paso #16 El bit BE (Backup elegibility) no esta present y BS (Backup State) esta backed up");
            } else {
                console.log("Paso #16 Se verifica que el bit BE (Backup elegibility) no esta presente en los flags de 'authData', y que el bit BS (Backup State) tampoco lo esta");
            }
            console.log("Paso #17 omitido");
            console.log("Paso #18 omitido");
                        
            // get the length of the credential ID
            const dataView = new DataView(new ArrayBuffer(2));
            const idLenBytes = authData.slice(53, 55);
            idLenBytes.forEach((value, index) => dataView.setUint8(index, value));
            const credentialIdLength = dataView.getUint16();
            // get the credential ID
            const credentialId = authData.slice(55, 55 + credentialIdLength);
            // get the public key object
            const publicKeyBytes = authData.slice(55 + credentialIdLength);
            // the publicKeyBytes are encoded again as CBOR
            const publicKeyObject = CBOR.decode(publicKeyBytes.buffer);
            const COSE_Key = {
                kty: 1,
                kid: 2,
                alg: 3,
                key_ops: 4,
                baseIv: 5
            }
            const pubKeyAlg = publicKeyObject[COSE_Key.alg]
            const validAlgorithms = options.pubKeyCredParams.map(pkcp => pkcp.alg);
            if (!validAlgorithms.includes(pubKeyAlg)) {
                error("Paso #19 public key algorithn is not supported");
            } else {
                console.log("Paso #19 Se verifica que el parametro 'alg' en la public key de la credencial dentro de 'authData' coincida con al menos uno de los alg en 'options.pubKeyCredParams'");
            }

            console.log("Paso #20 omitido");
            console.log("Paso #21 omitido");
            console.log("Paso #22 omitido");
            console.log("Paso #23 omitido");
            console.log("Paso #24 omitido");
            console.log("Paso #25 omitido");
            
            const authenticatorAttestationResponse = this.getAuthenticatorAttestationResponse(credential)
            
            console.log("Paso #26 y #27 se comprueba que no exista la credencial y se crea la credencial", authenticatorAttestationResponse);
            return true;
        },
        getAuthenticatorAttestationResponse: function(credential) {
            const { response } = credential;
            const authenticatorAttestationResponse = {
                "clientDataJSON": arrayToBase64String(response.clientDataJSON),
                "attestationObject": arrayToBase64String(response.attestationObject),
                "transports": response.getTransports(),
                "clientExtensionsJSON": this.getClientExtensionResults(credential),
            }
            authenticatorAttestationResponse.clientExtensionsJSON = JSON.stringify(authenticatorAttestationResponse.clientExtensionsJSON)
            return authenticatorAttestationResponse;
        },
        getClientExtensionResults: function(credential) {
            let clientExtensionResults;
            try {
                clientExtensionResults = credential.getClientExtensionResults(); //Edge preview throws exception as of build 180603-1447
                console.log("Paso #4 sea 'clientExtensionResults' el resultado de 'credential.getClientExtensionResults()'", clientExtensionResults);
            } catch {
                clientExtensionResults = {}
                console.error("Paso #4 fallo al ejecutar credential.getClientExtensionResults()");
                console.log("Paso #4 sea 'clientExtensionResults' vacio'", clientExtensionResults);
            }
            return clientExtensionResults;
        }
    }
})();
